import * as Yup from "yup";

/**
 * Validation class for Subscription Plan form
 * Contains validation schema for the subscription plan master fields
 */
class SubscriptionPlanValidationClass {
  /**
   * Subscription Plan validation schema
   * @param {function} t - Translation function
   * @returns {Yup.ObjectSchema} Validation schema for the subscription plan form
   */
  static subscriptionPlanValidation(t = (key) => key) {
    return Yup.object()
      .shape({
        name: Yup.string()
          .trim()
          .required(t("admin.subscription_plan_validation_name_required"))
          .max(150, t("admin.subscription_plan_validation_name_max_length")),
        user_type: Yup.string()
          .oneOf(["normal_user", "freelancer_user"], t("admin.subscription_plan_validation_user_type_invalid"))
          .required(t("admin.subscription_plan_validation_user_type_required")),
        duration: Yup.string()
          .oneOf(
            ["weekly", "monthly", "quarterly", "semiannually", "annually"],
            t("admin.subscription_plan_validation_duration_invalid")
          )
          .required(t("admin.subscription_plan_validation_duration_required")),
        apple_product_id: Yup.string().trim(),
        google_product_id: Yup.string().trim(),
      })
      .test(
        "at-least-one-product-id",
        t("admin.subscription_plan_validation_product_id_required"),
        function (values) {
          const { apple_product_id, google_product_id } = values || {};
          if ((apple_product_id && apple_product_id.trim()) || (google_product_id && google_product_id.trim())) {
            return true;
          }

          return this.createError({
            path: "apple_product_id",
            message: t("admin.subscription_plan_validation_product_id_required"),
          });
        }
      );
  }
}

export default SubscriptionPlanValidationClass;
